import { ReactNode, TableHTMLAttributes } from 'react';

interface Props extends TableHTMLAttributes<HTMLTableElement> {
  condensed?: boolean;
  children: ReactNode;
}

// Shared `.table .table-hover .table-iio` shell. Pass condensed for the
// `.table-condensed` variant used in project-detail tabs.
export function IioTable({ condensed, className, children, ...rest }: Props) {
  const cls = [
    'table table-hover',
    condensed ? 'table-condensed' : '',
    'table-iio',
    className ?? '',
  ].filter(Boolean).join(' ');
  return <table className={cls} {...rest}>{children}</table>;
}
